// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-spark-legend-label {
    fill: #5c5c5c;
}

.em-spark-color-legend-title {
    font-weight: 600;
}

.em-spark-color-legend-swatch {
    stroke: #8a8a8a;
    stroke-width: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/css/legend/spark.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".em-spark-legend-label {\r\n    fill: #5c5c5c;\r\n}\r\n\r\n.em-spark-color-legend-title {\r\n    font-weight: 600;\r\n}\r\n\r\n.em-spark-color-legend-swatch {\r\n    stroke: #8a8a8a;\r\n    stroke-width: 0.6;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
